import script from "./AccountLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountLayout.vue?vue&type=script&setup=true&lang=js"

import "./AccountLayout.vue?vue&type=style&index=0&id=287b0473&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-287b0473"]])

export default __exports__